var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { RECENT_ORDERS } from '@/stores/defs';
import accountMixin from '@Mixin/accountMixin';
var mixinName = {
    mixins: [accountMixin],
    computed: __assign({}, mapGetters({
        _getRecentOrders: RECENT_ORDERS.GET_RECENT_ORDERS,
        _hasRecentOrders: RECENT_ORDERS.HAS_RECENT_ORDERS,
    })),
    methods: __assign({}, mapActions({
        _setRecentOrders: RECENT_ORDERS.SET_RECENT_ORDERS,
    })),
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/recentOrdersMixin.ts
// module id = BFug
// module chunks = 18